import antd, { Form, Collapse, Row, Col, PageHeader } from 'antd';
import styled from 'styled-components';
import { ColSize } from 'antd/lib/col';

declare type ColSpanType = ColSize;

export const ColLayout: { [key: string]: ColSpanType } = {
    xl: {
        span: 12,
        offset: 0,
    },
    lg: {
        span: 12,
        offset: 0,
    },
    md: {
        span: 12,
        offset: 0,
    },
    sm: {
        span: 24,
        offset: 0,
    },
    xs: {
        span: 24,
        offset: 0,
    },
};
